export default {
  root: {
    padding: '28px'
  }
};
